import React from "react";
import "./style.scss";

interface IProps {
  thumbnailUrl: string;
  onClick: any;
}

const RecentlyViewProductListItem = ({ thumbnailUrl, onClick }: IProps) => {
  return (
    <li className="recently-view-product-list-item" onClick={onClick}>
      <img src={thumbnailUrl} alt="recently-view-product-img" />
    </li>
  )
}

export default RecentlyViewProductListItem;